import { createContext } from 'react';

const DesignContext = createContext({ resolution: 5 });

export default DesignContext;
export { DesignContext };
